"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.LSBDetect = exports.LSBDetectCallbackData = void 0;
var lsbInstall = require("./lsbsetup");
var lsbInstallStatus = require("./lsbupdate");
var LSBDetectCallbackData = /** @class */ (function () {
    function LSBDetectCallbackData() {
    }
    return LSBDetectCallbackData;
}());
exports.LSBDetectCallbackData = LSBDetectCallbackData;
var LSBDetect = /** @class */ (function () {
    function LSBDetect(dispatcher, successCallback, failCallback, lsbInstallContainerStr) {
        this._dispatcher = LSBV4.Dispatcher.GetDispatcher();
        this._successCallback = successCallback;
        this._failedCallback = failCallback;
        this._lsbInstallContainerStr = lsbInstallContainerStr;
        this._initEventHandler();
        lsbInstallStatus.LsbUpdateRender();
    }
    LSBDetect.prototype._initEventHandler = function () {
        var _this = this;
        ///LSB install events
        this._dispatcher.BatchAddEventListener(function (data) {
            LSBV4.Utility.Log('LSB install or update success');
            lsbInstall.LsbSetupClose();
            lsbInstallStatus.LsbUpdateClose();
            _this._dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.Detect, _this._dispatcher.LastCommandType);
            l.DTM.push({
                type: "eSupportProcess_Complete",
                name: "LSB:Success Machine Detection-" + _this._dispatcher.LastCommandType,
                action: "Button Click",
                errorInfo: {
                    message: "Detect Success:" + _this._dispatcher.LastCommandType
                }
            });
        }, LSBV4.Utility.EventTypeEnum.PingSuccess, LSBV4.Utility.EventTypeEnum.LSBUpdateSuccess);
        ///End of LSB install events
        this._dispatcher.BatchAddEventListener(function (data) {
            _this.EventHandler(0, data); //TODO: LSBV4 change to data.Exception
        }, 
        //Exceptions
        LSBV4.Utility.EventTypeEnum.DetectSuccess, LSBV4.Utility.EventTypeEnum.NotLenovo);
        this._dispatcher.BatchAddEventListener(function () {
            _this.EventHandler(LSBV4.Component.DetectExceptionEnum.CommunicationFailed);
        }, LSBV4.Utility.EventTypeEnum.DetectFailed);
        this._dispatcher.BatchAddEventListener(function () {
            _this.EventHandler(LSBV4.Component.DetectExceptionEnum.UserCancelled);
            l.DTM.Lmd.pusherrorinfTrack('LSB Install Cancel', 'Install User Cancel');
        }, LSBV4.Utility.EventTypeEnum.UserCancelled);
    };
    ;
    LSBDetect.prototype.EventHandler = function (exception, data) {
        exception = exception == null ? LSBV4.Component.DetectExceptionEnum.CommunicationFailed : exception;
        var returnData = new LSBDetectCallbackData();
        switch (exception) {
            case LSBV4.Component.DetectExceptionEnum.None:
                if (this._successCallback != null) {
                    if (data != null && !$.isEmptyObject(data)) {
                        if (data.Mtm != null) {
                            LSBV4.Utility.SetCookie("MTM", data.Mtm);
                            Cookies.set("ContactUsMTM", data.Mtm, { path: '/' });
                            returnData.MTM = data.Mtm;
                        }
                        if (data.Sn != null) {
                            LSBV4.Utility.SetCookie("SN", data.Sn);
                            Cookies.set("ContactUsSN", data.Sn, { path: '/' });
                            returnData.SN = data.Sn;
                        }
                        if (data.Os != null) {
                            LSBV4.Utility.SetCookie("OS", data.Os);
                        }
                    }
                    this._successCallback(returnData);
                }
                break;
            //case LSBV4.Component.DetectExceptionEnum.NotLenovo:
            //    if (this._failedCallback != null) {
            //        this._failedCallback();
            //    }
            //    break;
            case LSBV4.Component.DetectExceptionEnum.UserCancelled:
                if (this._failedCallback != null) {
                    this._failedCallback(true);
                }
                break;
            default:
                if (this._failedCallback != null) {
                    this._failedCallback(false);
                }
                break;
        }
    };
    ;
    LSBDetect.prototype.Start = function () {
        var mtm = Cookies.get('MTM');
        var sn = Cookies.get('SN');
        if (mtm != null && mtm !== "") {
            var returnData = new LSBDetectCallbackData();
            returnData.MTM = mtm;
            returnData.SN = sn;
            this._successCallback(returnData);
        }
        else {
            this._dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.Detect, LSBV4.Component.CommandTypeEnum.ScanStatus); //TODO:LSBV4 logic to uncomment this
        }
    };
    return LSBDetect;
}());
exports.LSBDetect = LSBDetect;
var _lsbDetect;
//let _dispatcher = LSBV4.Dispatcher.GetDispatcher();
var init = function (successCallback, failCallback, lsbInstallContainerStr) {
    _lsbDetect = new LSBDetect(LSBV4.Dispatcher.GetDispatcher(), successCallback, failCallback, lsbInstallContainerStr);
    return _lsbDetect;
};
exports.init = init;
